import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "../../../../components/Common/Modal/Modal";
import classes from "./SeriesDeleteModal.module.scss";
import { deleteProgramActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { FormattedMessage } from "react-intl";

const SeriesDeleteModal = ({
  deleteModal,
  setDeleteModal,
  programData,
  setDeleteSeriesData,
}) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const handleDelete = () => {
    if (programData?.PublishedbyMe && !programData?.Status) {
      dispatch(
        deleteProgramActionHandler(
          programData?.ID,
          setDeleteSeriesData,
          setLoader
        )
      );
    } else {
      setDeleteModal(!deleteModal);
    }
  };

  return (
    <Modal
      handleSubmit={handleDelete}
      isOpen={deleteModal}
      heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
      toggle={() => setDeleteModal(!deleteModal)}
      buttonLabel1={<FormattedMessage id="OK_TXT" />}
      buttonLabel2={
        programData?.PublishedbyMe && !programData?.Status ? (
          <FormattedMessage id="USERGRP_CANCELBTN_TEXT" />
        ) : (
          ""
        )
      }
      width={"40.2"}
      height={"22.9"}
      loading={loader}
    >
      <div className={classes.series_delete}>
        {!programData?.PublishedbyMe ? (
          <FormattedMessage id="PROGRAM_DELETE_MSG" />
        ) : programData?.Status ? (
          <FormattedMessage id="DISTRIBUTE_PROGRAM_DELETE_MSG" />
        ) : (
          <FormattedMessage id="DELETE_PROGRAM_MSG" />
        )}
      </div>
    </Modal>
  );
};

export default SeriesDeleteModal;
